const dataEl = document.querySelector('.video-splide');
if (dataEl && dataEl.dataset.id) {
  let vidSplide = new Splide(`.splide-${dataEl.dataset.id}`);
  // let thumbs = new Splide(`.splide-${dataEl.dataset.id} ~ .splide-thumbs`);
  vidSplide.on('move', function () {
    window.pauseAllMedia();
  });
  // yt thumbnail fallbacks
  vidSplide.on('mounted', function () {
    const ytThumbs = vidSplide.root.querySelectorAll('picture.yt-thumb');
    if (ytThumbs) {
      ytThumbs.forEach((el) => {
        const imgEl = el.querySelector('img');
        // https://stackoverflow.com/a/6575319
        const poll = setInterval(() => {
          if (imgEl.naturalWidth) {
            clearInterval(poll);
            if (imgEl.naturalWidth <= 120) {
              const sourceEls = el.querySelectorAll('source');
              if (sourceEls) {
                for (let j = 0; j < sourceEls.length; j++) {
                  if (sourceEls[j].getAttribute('srcset').includes('maxresdefault')) {
                    el.removeChild(sourceEls[j]);
                  }
                }
              }
            }
          }
        }, 250);
      });
    }
  });
  // init splide
  // vidSplide.sync(thumbs);
  vidSplide.mount();

  // thumbs events
  // thumbs.on('ready resize', function () {
  //   thumbs.options.height = vidSplide.root.querySelector('.splide__track').offsetHeight;
  //   thumbs.refresh();
  // });
  // init thumbs
  // thumbs.mount();

  // theme editor
  // if (window.Shopify.designMode && vidSplide && thumbs) {
  if (window.Shopify.designMode && vidSplide) {
    // reinit splide on section changes
    document.addEventListener('shopify:section:load', (event) => {
      vidSplide = new Splide(`.splide-${dataEl.dataset.id}`);
      // thumbs = new Splide(`.splide-${dataEl.dataset.id} ~ .splide-thumbs`);
      vidSplide.on('move', function () {
        window.pauseAllMedia();
      });
      // init splide & thumbs
      // vidSplide.sync(thumbs);
      vidSplide.mount();
      // thumbs events
      // thumbs.on('ready resize', function () {
      //   thumbs.options.height = vidSplide.root.querySelector('.splide__track').offsetHeight;
      //   thumbs.refresh();
      // });
      // thumbs.mount();
    });

    // change slide and pause play on block select
    document.addEventListener('shopify:block:select', (event) => {
      const index = parseInt(event.target.dataset.index);
      if (typeof index === 'number') {
        vidSplide.go(index);
      }
    });
  }
}
